<template>
  <div class="max-w-lg mx-auto p-4">
    <div class="flex justify-between items-center">
      <img v-if="!!logoUrl" class="w-56" alt="Logo" :src="logoUrl">
    </div>

    <main class="pt-8 mb-6">
      <div>
        <template-field :field="{ templateOptions: { description: confirmationMessage }}"></template-field>
      </div>
    </main>
  </div>
</template>

<script>
import TemplateField from "../form-controls/TemplateField.vue";

export default {
  name: "Confirm",
  components: { TemplateField },
  props: ["response", "form"],
  created() {
    const hasResponse = !!this.response;
    if (!hasResponse) {
      this.$router.replace(`/webform/${this.webformId}`);
    }
  },
  mounted() {
    this.$store.commit("clearPrevious");
    this.$store.commit("clearCurrent");
  },
  computed: {
    webformId() {
      return this.$route.params.id;
    },
    logoUrl() {
      return this.$store.state.logoUrl;
    },
    confirmationMessage() {
      if (!this.form || !this.form.help) {
        return [];
      }
      return (this.form.help.confirm || "")
        .replace("{{ response }}", this.response)
        .replace("{{ URN }}", this.response)
        .replace("{{response}}", this.response)
        .replace("{{URN}}", this.response);
    }
  }
};
</script>
